<div id="dialogHeader" [class]="headerBackgroundColor">
  <div>{{header}}</div>
  <mat-icon (click)="dialogRef.close(null)" class="pointer">close</mat-icon>
</div>
<mat-card-content dir="rtl">

  <div class="pa-10">
    <p [innerHtml]="content"></p>
    <textarea class="mt-10" lang="fa" matInput rows="5" placeholder="شرح دلیل " value="example"
      [(ngModel)]="description" *ngIf="HasString"></textarea>
  </div>

  <div class="center pa-5">
    <button *ngIf="IsYesNo" mat-button color="primary" (click)="close('yes',description);" class="">بله</button>
    <button *ngIf="IsYesNo" mat-button color="warn" (click)="close('no');" class="mr-10">خیر</button>
    <button *ngIf="AgreeNotAgree" mat-button color="primary" (click)="close('yes');" class="">بله، موافقم</button>
    <button *ngIf="AgreeNotAgree" mat-button color="warn" (click)="close('no');" class="mr-10">نه، ممنونم</button>
    <button *ngIf="LoginOrNot" mat-button color="primary" (click)="close('yes');" class="">باشه، موافقم</button>
    <button *ngIf="LoginOrNot" mat-button color="warn" (click)="close('no');" class="mr-10">مایل نیستم</button>
    <button *ngIf="IsOk" mat-button color="primary" (click)="close('ok');" class="mr-10">متوجه شدم</button>
  </div>

</mat-card-content>